import React from 'react';
import { Helmet } from 'react-helmet';
import CenteredContent from '../../components/CenteredContent';
import ArticleItem from '../../components/ArticleItem';

import { getHelpfulArticles } from '../../helpers/getHelpfulArticles';
import './HelpfulArticles.scss';

function HelpfulArticles() {
  const helpfulArticles = getHelpfulArticles();
  const articleCategoryQuery = getUrlQuery();

  return (
    <CenteredContent className="helpful-articles">
      <Helmet>
        <meta name="description" content="Helpful Articles" />
        <meta itemprop="description" content="Helpful Articles" />
        <meta property="og:description" content="Helpful Articles" />
      </Helmet>

      <div className="helpful-articles__content">
        <div className="helpful-articles__header">Helpful Articles</div>
        <div className="helpful-articles__list">
          {Object.entries(helpfulArticles).map(([category, articleList]) => (
            <ArticleItem
              isOpen={articleCategoryQuery === category}
              key={category}
              category={category}
              articleList={articleList}
            />
          ))}
        </div>
      </div>
    </CenteredContent>
  );
}

function getUrlQuery() {
  return window.location.search.replace('?', '').replace(/%20/g, ' ');
}

export default HelpfulArticles;
